import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

const HeaderDropdown = props => (
  <UncontrolledDropdown nav inNavbar>
    <DropdownToggle nav caret>
      {props.title}
    </DropdownToggle>
    <DropdownMenu>{props.children}</DropdownMenu>
  </UncontrolledDropdown>
);

HeaderDropdown.propTypes = {
  title: PropTypes.string,
  children: PropTypes.array.isRequired,
};

export default HeaderDropdown;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js